import { EmployeeSalesReport } from '../../pages';
import { payrollStore } from '../../stores';
import { monthName, theYear } from '../../utils/utils';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { PayrollController } from '../../controllers';
import { date, object } from 'yup';

const CommissionContainer = () => {
	const [comTypeModal, setComTypeModal] = useState(false);
	const [saleSheetModal, setSaleSheetModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [filterPeriod, setFilterPeriod] = useState(`${monthName} ${theYear}`);
	const showComTypeModal = () => {
		setComTypeModal(true);
	};

	const showSaleSheetModal = () => {
		setSaleSheetModal(true);
	};
	const onSubmit = async payload => {
		let query;
		if (payload && Object.keys(payload).length > 0) {
			query = `startDate=${payload.startDate}&endDate=${payload.endDate}&dateField=salesDate`;
			setFilterPeriod(
				`${payload?.startDate.toDateString()} - ${payload.endDate.toDateString()}`
			);
		}
		setLoading(true);
		await PayrollController.getSalesList(query);
		setLoading(false);
	};
	const validationSchema = () => {
		return object({
			startDate: date().required('Start Date is required'),
			endDate: date().required('End Date is required'),
		});
	};
	useEffect(() => {
		const setTransactions = async () => {
			setLoading(true);
			await Promise.all([
				PayrollController.getSalesList(),
				PayrollController.getProductList(),
				PayrollController.getDeductions(),
			]);
			setLoading(false);
		};
		setTransactions();
	}, []);

	const refresh = async () => {
		setLoading(true);
		await PayrollController.getSalesList();
		setLoading(false);
	};

	const closeModal = () => {
		setComTypeModal(false);
		setSaleSheetModal(false);
	};

	return (
		<EmployeeSalesReport
			comTypeModal={comTypeModal}
			saleSheetModal={saleSheetModal}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			filterPeriod={filterPeriod}
			showComTypeModal={showComTypeModal}
			showSaleSheetModal={showSaleSheetModal}
			closeModal={closeModal}
			refresh={refresh}
			loading={loading}
			salesList={payrollStore.salesList}
		/>
	);
};

export default observer(CommissionContainer);
